const { REACT_APP_CLOUDFRONT } = process.env;
const MAP_PATH = `${REACT_APP_CLOUDFRONT}/network-map`;
const mapData = [
  { value: 'all', name: 'All networks', count: 47, image: `${MAP_PATH}/map-all.png` },
  { value: 'angsana', name: 'Angsana', count: 15, image: `${MAP_PATH}/map-angsana.png` },
  { value: 'banyan Tree', name: 'Banyan Tree', count: 27, image: `${MAP_PATH}/map-banyantree.png` },
  { value: 'cassia', name: 'Cassia', count: 2, image: `${MAP_PATH}/map-cassia.png` },
  { value: 'dhawa', name: 'Dhawa', count: 2, image: `${MAP_PATH}/map-dhawa.png` },
  { value: 'laguna', name: 'Laguna', count: 1, image: `${MAP_PATH}/map-laguna.png` }
];

export { mapData };


// WEBPACK FOOTER //
// ./src/data/SanctuaryClub/locations.js